import { ComponentType, ReactElement } from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { LinearProgress } from 'beam'
import { Permission } from './permissions.constants'
import RequiresPermissions from './RequiresPermissions.component'
import { useFeatureFlags, useFeatureFlagValue } from '../FeatureFlags'
import { FeatureFlagName } from '../App/app.api'
import { datadogRum } from '@datadog/browser-rum'

export interface PrivateRouteProps<P> {
  component: ComponentType<P & RouteProps>,
  path: string,
  permissions: readonly Permission[],
  featureFlag?: FeatureFlagName,
}

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
export const PrivateRoute = <P, >({ component, path, permissions, featureFlag = '' as $TSFIXME }: PrivateRouteProps<P>): ReactElement => {
  const { featureFlagClient, launchDarklyProps } = useFeatureFlags()

  const isFeatureAvailable = useFeatureFlagValue(featureFlag)
  if ((launchDarklyProps?.implementation === 'LAUNCH_DARKLY' && featureFlagClient === null)) {
    return <LinearProgress />
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
  } else if (featureFlag === '' as $TSFIXME || isFeatureAvailable) {
    if (path.includes('insights')) {
      datadogRum.startView({
        name: path,
        service: 'bi-insights-client',
      })
    } else {
      datadogRum.startView({
        name: path,
      })
    }
    return (
      <RequiresPermissions
        permissions={permissions}
        authorized={<Route path={path} component={component} />}
        unauthorized={<Redirect to={'/'} />}
      />
    )
  } else {
    return (
      <Redirect to={'/'} />
    )
  }
}
